module.exports = __webpack_public_path__ + "img/Ireland.0fc1b5b9.png";